import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';

export const ApiFile: ITypeSpecificPolicy<types.ApiFile> = {

  fields: {
    formattedFileSize: {
      read: (existing, {
        readField
      }) => {
        const sizeBytes = readField<number>('sizeBytes') ?? 0;
        const interval = 1024;
        const kbSize = interval;
        const mbSize = kbSize * interval;
        const gbSize = mbSize * interval;

        if (sizeBytes >= gbSize) {
          return (sizeBytes / gbSize).toFixed(2) + 'GB';
        }

        if (sizeBytes >= mbSize) {
          return (sizeBytes / mbSize).toFixed(2) + 'MB';
        }

        if (sizeBytes >= kbSize) {
          return (sizeBytes / kbSize).toFixed(2) + 'kB';
        }

        return sizeBytes + 'B';
      }
    }
  }
};



